export { default } from './FullPaywall';
